"use client";

import { ArrowUpRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Construction() {
  const headlineWords = [{
    text: "Formexa",
    italic: false
  }, {
    text: "Construction",
    italic: false
  }, {
    text: "LTD",
    italic: false,
    lineBreak: true
  }, {
    text: "",
    italic: true
  }];
  const {
    ref: eyebrowRef,
    isVisible: eyebrowVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const {
    ref: headlineRef,
    isVisible: headlineVisible
  } = useRevealOnScroll<HTMLHeadingElement>({
    threshold: 0.1
  });
  const {
    ref: manifestoRef,
    isVisible: manifestoVisible
  } = useRevealOnScroll<HTMLParagraphElement>({
    threshold: 0.2
  });
  const {
    ref: ctaRef,
    isVisible: ctaVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const {
    ref: imageRef,
    isVisible: imageVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const {
    ref: scrollRef,
    isVisible: scrollVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  return <section data-section-id="3572" id="líderes-en-construcción" className="relative min-h-screen w-full overflow-hidden bg-background pt-40 pb-32 dark bg-background text-foreground">
      <div className="mx-auto max-w-[1440px] px-6 md:px-10 lg:px-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-10 items-center">
          {}
          <div className="order-2 lg:order-1 lg:col-span-7">
            {}
            <div ref={eyebrowRef} className={`mb-10 transition-all duration-700 ease-out ${eyebrowVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
              
            </div>

            {}
            <h1 ref={headlineRef} className="font-default font-bold text-foreground leading-[0.95] tracking-tight" style={{
            fontSize: "clamp(4rem, 8vw, 8rem)"
          }}>
              {headlineWords.map((word, i) => <span data-index={i} key={i} className="inline-block overflow-hidden align-bottom">
                  <span className={`inline-block transition-all duration-700 ease-out ${headlineVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-full"} ${word.italic ? "italic text-primary" : ""}`} style={{
                transitionDelay: `${i * 40 + 100}ms`
              }}>
                    {word.text}
                    {i < headlineWords.length - 1 && !word.lineBreak && "\u00A0"}
                  </span>
                  {word.lineBreak && <br />}
                </span>)}
            </h1>

            {}
            

            {}
            <div ref={ctaRef} className={`mt-10 transition-all duration-1000 ease-out ${ctaVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`} style={{
            transitionDelay: "600ms"
          }}>
              <Button asChild size="lg" className="group h-auto bg-primary px-8 py-4 text-white hover:bg-primary/90 font-default text-sm tracking-wide">
                <Link to="/ContactPage">
                  <span>Request a quote</span>
                  <ArrowUpRight className="ml-1 size-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                </Link>
              </Button>
            </div>
          </div>

          {}
          <div ref={imageRef} className={`order-1 lg:order-2 lg:col-span-5 transition-all duration-1200 ease-out ${imageVisible ? "opacity-100 scale-100" : "opacity-0 scale-95"}`}>
            <div className="relative">
              <div className="relative overflow-hidden aspect-[4/5] lg:aspect-[3/4]">
                <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1719873/img/concrete_formwork_vancouver.webp" alt="Trabajos de encofrado de concreto en una obra de construcción en Vancouver" loading="lazy" decoding="async" className={`h-full w-full object-cover transition-transform duration-[8000ms] ease-out ${imageVisible ? "scale-105" : "scale-100"}`} src="https://genuine-manatee.10web.cloud/wp-content/uploads/2026/06/2716576e-9c6d-4582-bed9-5059676064e1.jpg" src="https://genuine-manatee.10web.cloud/wp-content/uploads/2026/06/ba80d23c-0a52-444b-ae67-08e0f506de75.jpg" src="https://genuine-manatee.10web.cloud/wp-content/uploads/2026/06/ba80d23c-0a52-444b-ae67-08e0f506de75.jpg" />
                {}
                <div className="absolute inset-0 bg-gradient-to-t from-[hsl(0_0%_0%/0.6)] via-transparent to-transparent !h-[470px] !w-[390px]" />
              </div>

              {}
              <div className={`absolute bottom-6 right-6 lg:bottom-8 lg:right-8 transition-all duration-1000 ease-out ${imageVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
              transitionDelay: "800ms"
            }}>
                <span className="font-default italic text-sm lg:text-base text-white drop-shadow-md"></span>
              </div>
            </div>
          </div>
        </div>

        {}
        <div ref={scrollRef} className={`mt-24 lg:mt-32 flex flex-col items-center gap-3 transition-all duration-1000 ease-out ${scrollVisible ? "opacity-100" : "opacity-0"}`} style={{
        transitionDelay: "1000ms"
      }}>
          <span className="font-default text-[11px] uppercase tracking-[0.3em] text-muted-foreground">
            Scroll
          </span>
          <div className="relative h-16 w-px overflow-hidden bg-border">
            <div className="absolute top-0 left-0 h-8 w-full bg-foreground animate-[scrollLine_2s_ease-in-out_infinite]" />
          </div>
        </div>
      </div>

      <style>{`
        @keyframes scrollLine {
          0% { transform: translateY(-100%); }
          100% { transform: translateY(200%); }
        }
      `}</style>
    </section>;
}